var React = require('react');

function ContactUsInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"Ellipse_52","data-name":"Ellipse 52","fill":"none","stroke":"#0070c1","strokeWidth":"2","key":0},[React.createElement("circle",{"cx":"40","cy":"40","r":"40","stroke":"none","key":0}),React.createElement("circle",{"cx":"40","cy":"40","r":"39","fill":"none","key":1})]),React.createElement("path",{"id":"Envelope","d":"M577,143l16.2,14.72L609.162,143H577v24.493h32.162V152.91","transform":"translate(-553.5 -115.5)","fill":"none","stroke":"#0070c1","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]);
}

ContactUsInline.defaultProps = {"id":"Small_circled_icon","data-name":"Small circled icon","width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = ContactUsInline;

ContactUsInline.default = ContactUsInline;
